"use client"

import type { TrackReferenceOrPlaceholder } from "../react"
import { cn } from "@workspace/ui/lib/utils"
import { AgentAudioVisualizerBar } from "./agent-audio-visualizer-bar"
import { AgentTrackToggle } from "./agent-track-toggle"

export interface AgentTrackControlProps {
  source: "camera" | "microphone" | "screen_share"
  pressed?: boolean
  pending?: boolean
  disabled?: boolean
  className?: string
  audioTrack?: TrackReferenceOrPlaceholder
  onPressedChange?: (pressed: boolean) => void
}

export function AgentTrackControl({
  source,
  pressed,
  pending,
  disabled,
  className,
  audioTrack,
  onPressedChange,
}: AgentTrackControlProps) {
  return (
    <div className={cn("flex items-center gap-0 rounded-md", className)}>
      <AgentTrackToggle
        source={source}
        pressed={pressed}
        pending={pending}
        disabled={disabled}
        onPressedChange={onPressedChange}
        className="peer/track group/track focus:z-10 has-[.audiovisualizer]:w-auto has-[.audiovisualizer]:px-3 has-[~_button]:rounded-r-none has-[~_button]:border-r-0 has-[~_button]:pr-2 has-[~_button]:pl-3"
      >
        {audioTrack && (
          <AgentAudioVisualizerBar
            barCount={3}
            state={pressed ? "speaking" : "disconnected"}
            audioTrack={pressed ? audioTrack : undefined}
            className="audiovisualizer"
          />
        )}
      </AgentTrackToggle>
    </div>
  )
}
